export const channelSavedSuccess = {
  title: '已成功更新',
};
